import { BaseDto } from "src/dtos/common/baseDto";

export interface PlcStatusLogDto extends BaseDto {
	plcid: number;
	plcaddressid: number;
	createdatetime: Date;
	id: number;
	value: string;
	remark: string;
	inserted: boolean;
	isModified: boolean;
}

export const defaultPlcStatusLogDto: PlcStatusLogDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	plcid: 0,
	plcaddressid: 0,
	createdatetime: new Date(),
	id: 0,
	value: '',
	remark: '',
	inserted: false,
	isModified: false,
};
